import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'
import RouteViewComponent from '../layouts/RouterBypass.vue'
import { utmCpntsArr, utmCpntsObj, } from '@/utils/obcfg'
import { useUTMStore } from 'obst/utm-store'
import obfn from '@/utils/obfn'
import i18n from '@/i18n'

const { t } = i18n.global

// UTM 路由设置
const UTMComponents = import('../pages/utm/UTMCpntsPage.vue')
const utmComponentsArr = Array.from(utmCpntsArr, (e: any) => {
  if (e.type === 'utm-campaign' || e.type === 'utm-content') {
    return {
      name: e.type,
      path: e.type,
      meta: { abbr: e.abbr, cate: 'utm-cpnt', title: e.name },
      component: () => UTMComponents,
      children: [
        {
          // 动态的 utm-campaign / utm-content
          path: ':name',
          name: e.type + '-detail',
          meta: { abbr: e.type === 'utm-campaign' ? 'cn-d' : 'cc-d', cate: 'utm-cpnt', title: e.name, parent: e.type },
          component: () => UTMComponents,
          props: true,
        },
      ],
    }
  } else {
    return {
      name: e.type,
      path: e.type,
      meta: { abbr: e.abbr, cate: 'utm-cpnt', title: t(e.name) },
      component: () => UTMComponents,
    }
  }
})

// obrmk 路由
const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'dashboard' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
      },
      {
        name: 'utm',
        path: '/utm',
        component: RouteViewComponent,
        children: [
          {
            name: 'utm-records',
            path: 'utm-records',
            meta: { title: 'UTM Generation' },
            component: () => import('../pages/utm/UTMRecordsPage.vue'),
          },
          {
            name: 'utm-components',
            path: 'utm-components',
            component: RouteViewComponent,
            // redirect: '/utm/utm-components/landing-page',
            children: utmComponentsArr,
          },
          {
            name: 'url-create',
            path: 'url-create',
            component: () => import('../pages/utm/UTMReacodAddPage.vue'),
          },
        ],
      },
      {
        name: 'settings',
        path: 'settings',
        component: () => import('../pages/settings/Settings.vue'),
      },
      {
        name: 'support',
        path: 'support',
        component: () => import('../pages/support/Support.vue'),
      },
      {
        name: 'company',
        path: '/company',
        component: RouteViewComponent,
        children: [
          {
            name: 'project',
            path: 'project',
            component: () => import('../pages/projects/ProjectsPage.vue'),
          },
          {
            name: 'member',
            path: 'member',
            component: () => import('../pages/company/Members.vue'),
          },
          {
            name: 'action-events',
            path: 'action-events',
            component: () => import('../pages/company/ActionEvents.vue'),
          },
        ],
      },
      {
        name: 'test',
        path: '/test/ui',
        component: () => import('../pages/test/TestUIPage.vue'),
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        meta: { noLogin: true },
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        name: 'verify',
        path: 'verify',
        meta: { noLogin: true },
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        name: 'signup',
        path: 'signup',
        meta: { noLogin: true },
        component: () => import('../pages/auth/Signup.vue'),
      },
      {
        name: 'recover-password',
        path: 'recover-password',
        meta: { noLogin: true },
        component: () => import('../pages/auth/RecoverPassword.vue'),
      },
      {
        name: 'recover-password-email',
        path: 'recover-password-email',
        meta: { noLogin: true },
        component: () => import('../pages/auth/CheckTheEmail.vue'),
      },
      {
        name: 'maintenance',
        path: 'maintenance',
        meta: { noLogin: true },
        component: () => import('../pages/auth/Maintenance.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

const proxyHost = import.meta.env.VITE_PROXY_HOST
const proxyPath = import.meta.env.VITE_PROXY_PATH
const baseUrl = window.location.hostname === proxyHost ? `/${proxyPath}` : `/`;
// console.log("路由",import.meta.env.MODE,proxyHost,proxyPath,baseUrl)
const router = createRouter({
  history: createWebHistory(baseUrl),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

const defaultTitle = 'URLB'
router.beforeEach((to: any, from: any, next: any) => {
  document.title = to.meta.title ? t(to.meta.title) : defaultTitle
  if (to.path == '/utm/utm-components') {
    const utmStore = useUTMStore()
    router.push(`/utm/utm-components/${utmCpntsObj[utmStore.curCpntType]['type']}`)
  }
  next()
})
router.afterEach((to: any, from: any) => {
  obfn.log('router.after', to.path)
})

export default router
